import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-844468a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page-block-wrap" }
const _hoisted_2 = { class: "home-page-block" }

import {HomePageBlockHeader, HomePageBlockInfo, LatestNews} from "@/features";
import {HomeTabs} from "@/widgets";

export default /*#__PURE__*/_defineComponent({
  __name: 'home-page-block',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(HomePageBlockHeader)),
      _createVNode(_unref(HomePageBlockInfo)),
      _createVNode(_unref(HomeTabs)),
      _createVNode(_unref(LatestNews), { class: "home-page-block-latest-news" })
    ])
  ]))
}
}

})